import { Amplify } from '../Amplify.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function clearCredentials() {
    return Amplify.Auth.clearCredentials();
}

export { clearCredentials };
//# sourceMappingURL=clearCredentials.mjs.map
